/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns the organization ID if the tenant is part of an organization.
 *
 * @agent-skills: tenant-context
 */
export const useOrgId = (): string | undefined => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.orgId;
};
